/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_01_Detail_Tournament_2_HeadingInputs */

const en_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidence-based entry point`)
};

const es_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punto de entrada basado en evidencia`)
};

const de_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evidenzbasierter Einstiegspunkt`)
};

const zh_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有证据支持的起点`)
};

const ar_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نقطة دخول قائمة على الأدلة`)
};

const fr_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Point d’entrée fondé sur des preuves`)
};

const vi_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điểm vào dựa trên bằng chứng`)
};

const sw_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mahali pa kuanzia panapotegemea ushahidi`)
};

const th_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จุดเริ่มต้นที่อิงหลักฐาน`)
};

const bs_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ulazna tačka zasnovana na dokazima`)
};

const ja_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`エビデンスに基づく入り口`)
};

const ko_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`근거에 기반한 출발점`)
};

const pt_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um ponto de partida baseado em evidências`)
};

const it_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un punto di partenza basato sulle evidenze`)
};

const sv_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En evidensbaserad startpunkt`)
};

const nl_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een wetenschappelijk onderbouwd startpunt`)
};

const da_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et evidensbaseret udgangspunkt`)
};

const nb_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et evidensbasert utgangspunkt`)
};

const fi_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näyttöön perustuva lähtökohta`)
};

const pl_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Punkt wyjścia oparty na dowodach`)
};

const ru_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Научно обоснованная точка входа`)
};

const tr_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanıta dayalı bir başlangıç noktası`)
};

const hi_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रमाण पर आधारित शुरुआती बिंदु`)
};

const id_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titik awal berbasis bukti`)
};

const ms_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titik permulaan berasaskan bukti`)
};

const cs_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Výchozí bod podložený důkazy`)
};

const el_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Τεκμηριωμένο σημείο εισόδου`)
};

const he_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`נקודת כניסה מבוססת ראיות`)
};

const af_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewysgebaseerde beginpunt`)
};

const hu_method_content_step_01_detail_tournament_2_heading = /** @type {(inputs: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bizonyítékokon alapuló belépési pont`)
};

/**
* | output |
* | --- |
* | "Evidence-based entry point" |
*
* @param {Method_Content_Step_01_Detail_Tournament_2_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_01_detail_tournament_2_heading = /** @type {((inputs?: Method_Content_Step_01_Detail_Tournament_2_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_01_Detail_Tournament_2_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "de") return de_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "zh") return zh_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "ar") return ar_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "fr") return fr_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "vi") return vi_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "sw") return sw_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "th") return th_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "bs") return bs_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "ja") return ja_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "ko") return ko_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "pt") return pt_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "it") return it_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "sv") return sv_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "nl") return nl_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "da") return da_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "nb") return nb_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "fi") return fi_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "pl") return pl_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "ru") return ru_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "tr") return tr_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "hi") return hi_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "id") return id_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "ms") return ms_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "cs") return cs_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "el") return el_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "he") return he_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "af") return af_method_content_step_01_detail_tournament_2_heading(inputs)
	if (locale === "hu") return hu_method_content_step_01_detail_tournament_2_heading(inputs)
	return en_method_content_step_01_detail_tournament_2_heading(inputs)
});